<template>
    <JingQingQiDai/>
</template>

<script>
    import JingQingQiDai from "../JingQingQiDai";
    export default {
        components: {
          JingQingQiDai
        }
    }
</script>

<style scoped>

</style>
